export const filterMonthlyDataByCamera = (monthlyData, selectedCameraId) => {

    if (monthlyData.length === 0) {
        return []
    }

    let filteredData = [];

    if (selectedCameraId === 'All') {
        filteredData = monthlyData;
    } else {
        for (let i = 0; i < monthlyData.length; i++) {
            const row = monthlyData[i];
            if (row.camera_id === selectedCameraId) {
                filteredData.push(row);
            } else if (row.camera_id === null) {
                filteredData.push(row);
            } else {
                let hasMonth = filteredData.some(monthData => monthData.month === row.month);

                if (!hasMonth) {
                    const emptyMonth = {
                        'year': row.year,
                        'month': row.month,
                        'total_infringements': 0
                    }
                    filteredData.push(emptyMonth);
                }
            }
        }

    }

    const tempAggregation = new Map();

    filteredData?.forEach(d => {
        const month = d.month;
        const totalInfringements = parseInt(d.total_infringements);

        if (!tempAggregation.has(month)) {
            tempAggregation.set(month, {
                'total_infringements': 0,
                'year': d.year
            });
        }

        const monthData = tempAggregation.get(month);
        monthData.total_infringements += totalInfringements;


    });

    const aggregatedData = [];

    for (const [monthNum, monthValue] of tempAggregation) {
        aggregatedData.push({
            year: monthValue.year,
            month: parseInt(monthNum),
            hw_id: filteredData[0]?.hw_id,
            camera_id: selectedCameraId === 'All' ? 'All' : filteredData[0]?.camera_id,
            total_infringements: monthValue.total_infringements

        });
    }

    return aggregatedData;
};


export const filterWeeklyDataByCamera = (weeklyData, selectedCameraId) => {

    if (weeklyData.length === 0) {
        return []
    }


    let filteredData = [];

    if (selectedCameraId === 'All') {
        filteredData = weeklyData;
    } else {
        for (let i = 0; i < weeklyData.length; i++) {
            const row = weeklyData[i];
            if (row.camera_id === selectedCameraId) {
                filteredData.push(row);
            } else if (row.camera_id === null) {
                filteredData.push(row);
            } else {
                let hasWeek = filteredData.some(weekData => weekData.week === row.week);

                if (!hasWeek) {
                    const emptyMonth = {
                        'year': row.year,
                        'week_start_date': row.week_start_date,
                        'total_infringements': 0
                    }
                    filteredData.push(emptyMonth);
                }
            }
        }

    }

    const tempAggregation = new Map();

    filteredData?.forEach(d => {
        const week = d.week;
        const totalInfringements = parseInt(d.total_infringements);

        if (!tempAggregation.has(week)) {
            tempAggregation.set(week, {
                'total_infringements': 0,
                'year': d.year,
                'week_start_date': d.week_start_date
            });
        }

        const weekData = tempAggregation.get(week);
        weekData.total_infringements += totalInfringements;
    });

    const aggregatedData = [];

    for (const [weekNum, weekValue] of tempAggregation) {
        aggregatedData.push({
            year: weekValue.year,
            week: parseInt(weekNum),
            week_start_date: weekValue.week_start_date,
            hw_id: filteredData[0]?.hw_id,
            camera_id: selectedCameraId === 'All' ? 'All' : filteredData[0]?.camera_id,
            total_infringements: weekValue.total_infringements

        });
    }


    return aggregatedData;
};


export const filterDailyDataByCamera = (dailyData, selectedCameraId) => {

    let filteredData = [];

    if (selectedCameraId === 'All') {
        filteredData = dailyData;
    } else {
        for (let i = 0; i < dailyData.length; i++) {
            const row = dailyData[i];
            if (row.camera_id === selectedCameraId) {
                filteredData.push(row);
            } else if (row.camera_id === null) {
                filteredData.push(row);
            } else {
                let hasDay = filteredData.some(dayData => dayData.day_number === row.day_number);

                if (!hasDay) {
                    const emptyMonth = {
                        'year': row.year,
                        'day_number': row.day_number,
                        'day': row.day,
                        'daily_infringements': 0
                    }
                    filteredData.push(emptyMonth);
                }
            }
        }

    }

    const tempAggregation = new Map();

    filteredData?.forEach(d => {
        const dayNumber = d.day_number;
        const dayName = d.day;
        const dailyInfringements = parseInt(d.daily_infringements);

        if (!tempAggregation.has(dayNumber)) {
            tempAggregation.set(dayNumber, {
                'daily_infringements': 0,
                'day': dayName
            });
        }

        const dayData = tempAggregation.get(dayNumber);
        dayData.daily_infringements += dailyInfringements;

    });

    const aggregatedData = [];

    for (const [dayNum, dayValue] of tempAggregation) {
        aggregatedData.push({
            day_number: parseInt(dayNum),
            day: dayValue.day,
            hw_id: filteredData[0]?.hw_id,
            camera_id: selectedCameraId === 'All' ? 'All' : filteredData[0]?.camera_id,
            daily_infringements: dayValue.daily_infringements

        });
    }



    return aggregatedData;
};


export const filterHeatmapDataByCamera = (infringementData, cameraId) => {

    if (infringementData.length === 0) {
        return []
    }

    let filteredData = [];

    if (!cameraId) {
        filteredData = infringementData;
    }

    filteredData = cameraId === 'All'
        ? infringementData
        : infringementData.filter(d => d.camera_id === cameraId);


    const tempAggregation = new Map();

    filteredData?.forEach(d => {
        const dayName = d.day_name;
        const dayNumber = d.day_number;
        const hour = d.hour;
        const hourlyInfringements = parseInt(d.hourly_infringements);
        const hourOfGivenDay = `${dayNumber} ${hour}`;

        if (!tempAggregation.has(hourOfGivenDay)) {
            tempAggregation.set(hourOfGivenDay, {
                'day_name': dayName,
                'day_number': dayNumber,
                'hour': hour,
                'hourly_infringements': 0

            });
        }

        const hourOfGivenDayData = tempAggregation.get(hourOfGivenDay);
        hourOfGivenDayData.hourly_infringements += hourlyInfringements;
    });


    const aggregatedData = [];

    for (const [hourOfGivenDay, hourOfGivenDayValue] of tempAggregation) {
        aggregatedData.push({
            hw_id: filteredData[0]?.hw_id,
            camera_id: cameraId === 'All' ? 'All' : filteredData[0]?.camera_id,
            day_name: hourOfGivenDayValue.day_name,
            day_number: hourOfGivenDayValue.day_number,
            hour: hourOfGivenDayValue.hour,
            hourly_infringements: hourOfGivenDayValue.hourly_infringements

        });
    }

    aggregatedData.forEach(d => {
        if (d.hourly_infringements > 0) {
        }
    });


    return aggregatedData;
};

export const calculateTotalInfringementPercentage = (totalVehicles, totalInfringements) => {
    let infringementPercentage = 0
    if (totalVehicles > 0) {
        infringementPercentage = (totalInfringements / totalVehicles) * 100;

    }

    return infringementPercentage.toFixed(2);
};

export const checkForNoInfringementData = (monthlyData) => {
    let hasData = false;
    for (let i = 0; i < monthlyData.length; i++) {
        const data = monthlyData[i];

        if (data.total_infringements > 0) {
            hasData = true;
        }


    }
    return hasData;
}
